module.exports = __webpack_public_path__ + "static/media/forapproval.baabc96f.PNG";